class PaymentForm {
	constructor() {
		this._form;
		this.nextBtn;
		this.backBtn;
		this.skipBtn;

		this.formInitialised = false;
		this.onNext;
		this.onBack;
		this.onSkip;

		this.cardNumber;
		this.cardExpiryDate;
		this.securityCode;
		this.cardHolderName;
		
		this.merchantSessionKey = null;
		this.cardIdentifier = null;
		this.tokenExpiry = null;

		this.cardType = null;
		this.paymentSet = false;
	}

	async init(onNext, onBack, canSkip) {
		this.onNext = onNext;
		if (this._form == null) {
			this._form = htm('form', null, ge('payment-form-template').content.cloneNode(true));
			this.nextBtn = this._form.querySelector('#payment-form-next-btn');
			this.backBtn = this._form.querySelector('#payment-form-back-btn');
			this.skipBtn = this._form.querySelector('#skip-btn')

			this.cardNumber = this._form.querySelector('#card-number');
			this.cardExpiryDate = this._form.querySelector('#expiry-date');
			this.securityCode = this._form.querySelector('#security-code');
			this.cardHolderName = this._form.querySelector('#cardholder-name');
			
			this._email = this._form.querySelector('#user-email');
			this._phone = this._form.querySelector('#user-phone');

			let cc = this._form.querySelector('#card-number');
			onEv(cc, "keydown", this.cardKeyDown);
			onEv(cc, "blur", this.cardKeyDown);

			let ed = this._form.querySelector('#expiry-date');
			onEv(ed, "keydown", this.formatExpiry);

			onEv(this.nextBtn, 'click', this.next.bind(this));
			onEv(this.skipBtn, 'click', this.skip.bind(this));
			onEv(this.backBtn, 'click', onBack);

			this.skipBtn.style.display = canSkip ? 'block' : 'none';

			this.validation = new Validation(
				this._form, 
				this.nextBtn
			);
		}

		if(!this.formInitialised) {
			let reply = await API.get('payment-methods/init');
			this.opayoURL = reply.opayoURL;

			let sageJS = document.createElement('script');
			sageJS.id = 'sageJS';
			sageJS.type = 'text/javascript';
			sageJS.src = reply.jsURL;
			document.head.appendChild(sageJS);

			this.formInitialised = true;
		}
	}

	get form() {
		return this._form;
	}

	setCardholderName(firstName, lastName) {
		this.cardHolderName.value = firstName + ' ' + lastName;
	}

	set email(v) {
		this._email.value = v;
	}

	get email() {
		return this._email.value;
	}

	set phone(v) {
		this._phone.value = v;
	}
	
	get phone() {
		return this._phone.value;
	}

	get billingAddress() {
		return [
			this._form.querySelector('#address-street').value,
			this._form.querySelector('#address-line-2').value,
			this._form.querySelector('#address-town').value,
			this._form.querySelector('#address-region').value,
			this._form.querySelector('#address-postcode').value,
			this._form.querySelector('#address-country').value
		];
	}

	get isValid() {
		//TODO - VALIDATE THE FORM INFORMATION PROPERLY
		return true;
	}
	
	cardKeyDown(event) {
		// filter out non number
		let key = App.onlyNumbers(event);
		let full = false;
		if (key === false) return;

		let curPosition = this.selectionStart;
		let chars = this.value.replace(/[^0-9]+/g, '').split('');
		
		// identify card logo
		if (this.value.match(/^4.*/)) {
			this.cardType = 'visa';
			this.style.backgroundImage = "url('images/visa.png')";
			full = chars.length >= 19;
		}
		else if (this.value.match(/^3[^4|7].*/)) {
			this.cardType = 'diners';
			this.style.backgroundImage = "url('images/diners-club.png')";
			full = chars.length >= 15;
		}
		else if (this.value.match(/^(5[1-5]|2[2|7])/)) {
			this.style.backgroundImage = "url('images/mastercard.png')";
			this.cardType = 'mastercard';
			full = chars.length >= 16;
		}
		else {
			this.style.backgroundImage = "url('images/blank.png')";
			this.cardType = null;
		}
		
		this.value = '';

		do {
			if (
				this.value.length == curPosition && 
				key !== null && 
				!full
			) {
				this.value += key;
				key = null;
				curPosition++;
			}
			else if (chars.length) this.value += chars.shift();	
			if (
				(this.value.length == 4) ||
				(this.value.length == 9 && this.cardType != 'diners') ||
				(this.value.length == 11 && this.cardType == 'diners') ||
				(this.value.length == 14 && this.cardType != 'diners')
			) {
				if (this.value.length == curPosition) curPosition++;
				this.value += ' ';
			}
		} while (chars.length || key !== null);

		if (typeof(event) === KeyboardEvent) {
			this.setSelectionRange(curPosition, curPosition);
		}
	}

	formatExpiry(event) {
		if (!event.key) return;

		let ok = [
			'Backspace',
			'Tab',
			'Enter',
			'Escape',
			'Delete',
			'ArrowRight',
			'ArrowLeft',
			'Shift'
		];
		
		let kc = event.key;

		if (ok.indexOf(kc) !== -1) return;

		event.preventDefault();

		if (this.value.length > 4 || isNaN(kc)) return;
		
		let input = this.value.replace(/[^0-9]+/g, '') + kc;
		let cp = this.selectionStart + 1;
		this.value = '';
		for (let i = 0; i < input.length; i++) {
			this.value += input[i];
			if(i == 1) {
				if (this.value.length == cp) cp++;
				this.value += "/";
				if (this.value.length == cp) cp++;
			}
		}
		this.setSelectionRange(cp, cp);
	}

	next() {
		this.afterTokenise = this.onNext;
		this.getToken();
	}

	skip() {
		this.cardIdentifier = null;
		this.onNext();
	}

	async getToken() {
		let reply = await API.get('payment-methods/key');
		if (!reply) return;

		this.merchantSessionKey = reply.key.merchantSessionKey;

		sagepayOwnForm({merchantSessionKey: reply.key.merchantSessionKey})
		.tokeniseCardDetails({
			cardDetails: { 
				cardholderName: this.cardHolderName.value,
				cardNumber: this.cardNumber.value.replace(/[^0-9]+/g, ''), 
				expiryDate: this.cardExpiryDate.value.replace(/[^0-9]+/g, ''), 
				securityCode: this.securityCode.value 
			}, 
			onTokenised: (reply) => {
				if (reply.success) {
					this.cardIdentifier = reply.cardIdentifier;
					this.tokenExpiry = new Date();
					this.tokenExpiry.setMinutes(this.tokenExpiry.getMinutes() + 5);
					this.cardType = reply.cardType;
					this.afterTokenise();
				}
				else {
					this.cardIdentifier = null;
					for (let error of reply.errors) {
						makeToast(error.message);
					}
				}
			}
		});
	}

	get tokenHasExpired() {
		let now = new Date();
		return this.cardIdentifier !== null && this.tokenExpiry < now;
	}

	refreshToken(callback) {
		this.onTokenised = callback;
		this.getToken();
	}

	get cardEnding() {
		return this.cardNumber.value ? _("Card ending ") + this.cardNumber.value.replace(/[^0-9]+/g, '').substr(-4,4) : null;
	}

	get paymentData() {
		return this.cardIdentifier == null ? null : {
			merchantSessionKey: this.merchantSessionKey,
			cardIdentifier: this.cardIdentifier,
			cardEnding: this.cardEnding,
			expiryDate: this.cardExpiryDate.value,
			phone: this.phone,
			email: this.email,
			address: this.billingAddress,
			language: navigator.language,
			colorDepth: (screen.colorDepth - screen.colorDepth%8),
			screenHeight: screen.height,
			screenWidth: screen.width,
			timezone: (new Date()).getTimezoneOffset()
		};
	}

	threeDAuth(cReq, opayoTransId, acsUrl, container, onComplete) {
		// register an event listener for the challenge-end script result
		onEv(window, 'message', (e) => {
			if (e.origin != "https://" + window.location.hostname) return;
			let data = JSON.parse(e.data);
			if (data.status != "success") {
				makeToast("There was an error processing the payment details.");
			}
			onComplete();
		})

		// redirect the user to packaged url inside an iFrame
		container.innerHTML = "<iframe name='challenge-frame' width='100%' height='400px'></iframe>";
		window.open('', 'challenge-frame');
		let form = this.getChallengeForm(cReq, opayoTransId, acsUrl);
		document.body.appendChild(form);
		form.submit();
		state(container);
	}

	getChallengeForm(cReq, opayoTransId, acsUrl) {
		return htm('form', null, [
			input('hidden', null, cReq, null, {
				'name': "creq"
			}),
			input('hidden', null, opayoTransId, null, {
				'name': "threeDSSessionData"
			})
		], null, {
			'action': acsUrl,
			'method': "post",
			'target': "challenge-frame",
		});
	}
}